module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/is-pure.js
// module id = 127
// module chunks = 0